import { InViewLoader } from '../GC/InViewLoader'
import { initializeHowItWorks } from './how-it-works'
import { initializeTestimonialsSlider } from './testimonials'

const loadWistia = (cb) => {
  const alreadyLoaded = document.querySelector('.gc-wistia-loaded')

  if (!alreadyLoaded) {
    const src = 'https://fast.wistia.com/assets/external/E-v1.js'
    const scriptTag = document.createElement('script')
    const head = document.querySelector('head')
    scriptTag.src = src
    scriptTag.onload = () => {
      const body = document.querySelector('body')
      body.classList.add('gc-wistia-loaded')
      if (cb) {
        cb()
      }
    }
    head.appendChild(scriptTag)
  }
}

const onReady = function (cb, readyState) {
  readyState = readyState || 'complete'
  const alreadyLoaded = function () {
    return document.readyState === 'complete'
  }
  if (!alreadyLoaded()) {
    const onReady = function (event) {
      if (event.target.readyState === readyState || alreadyLoaded()) {
        cb()
      }
    }
    document.addEventListener('readystatechange', onReady)
  } else {
    cb()
  }
}

onReady(() => {
  const HomePageObserver = InViewLoader({
    elements: [
      {
        selector: '.homepage--how-it-works',
        callback: () => initializeHowItWorks(),
      },
      {
        selector: '.testimonial--slider',
        callback: () => initializeTestimonialsSlider(),
      },
    ],
  })

  const wistiaScrollListener = document.addEventListener(
    'scroll',
    () => {
      loadWistia()
    },
    { once: true }
  )

  const heroImage = document.querySelector('.signup--hero-image')

  heroImage.addEventListener(
    'click',
    () => {
      loadWistia(() => {
        try {
          window.wistiaInit = function (W) {
            // In an ideal world we'd pull this off the element itself.
            W.api('kb2prnxytc').play()
          }
          document.removeEventListener(wistiaScrollListener)
        } catch (e) {
          console.log(e)
        }
      })
    },
    {
      once: true,
    }
  )
}, 'interactive')
